import React, { useState } from 'react';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';
import { useSelector } from 'react-redux';

import Input from '../components/Input/Input';
import Button from '../components/Button/Button';
import SectionWrapper from '../components/Section/Section';
import Eye from '../assets/images/eye.svg';
import EyeSlash from '../assets/images/eye-slash.svg';
import CodeInputCustom from '../components/CodeInput/CodeInputCustom';
import DynamicMessage from './popup/DynamicMessage';

import {
  getInbRandomNumber, setupINB,
} from '../data-manager/info';

const SetupDigitalBanking = ({
  classes,
  restrictSpecialCharacters,
  preventSpecialCharacters,
  goToHasCompletedPage,
  goToHaveCompletedPage,
  goToReadyBothPage,
  goToSystemErrorPage,
  goToDigitalBankReadyPage,
}) => {
  const [formRedux] = useState(
    useSelector((state) => state.form),
  );

  const [digitalBanking, setDigitalBanking] = useState({
    accessCode: '',
    password: '',
    confirmPassword: '',
  });

  const getDigitalTrading = (name, value, error) => setDigitalBanking({
    ...digitalBanking,
    [name]: value,
    [`error${name}`]: error === '',
  });

  const [isError, setIsError] = useState('');
  const [typePassword, setTypePassword] = useState('password');
  const [confirmPassword, setConfirmPassword] = useState('password');
  const showPassword = () => (typePassword === 'password' ? setTypePassword('text') : setTypePassword('password'));
  const showConfirmPassword = () => (confirmPassword === 'password' ? setConfirmPassword('text') : setConfirmPassword('password'));

  const validateDigitalBanking = digitalBanking.accessCode && digitalBanking.password && digitalBanking.confirmPassword && digitalBanking.password === digitalBanking.confirmPassword && digitalBanking.erroraccessCode && !isError;

  const handleError = (value) => {
    setIsError(value);
  };

  const setupInbSubmisssion = () => {
    const { caseId, setupOnlineTrading } = formRedux.form;
    getInbRandomNumber(caseId).then(resp => {
      console.log(resp);
      const { randomNumber } = resp.data;
      if (!resp.error && randomNumber) {
        createPINBlock(digitalBanking.password, randomNumber);
        const cString = getEncryptedUserLoginMsg();
        const pString = getEncodingParameter();
        console.log('P_String, C_String ', pString, cString);
        if (pString && cString) {
          setupINB(caseId, digitalBanking.accessCode, pString, cString).then(setupResp => {
            console.log(setupResp);
            if (!setupResp.data.ErrorDetail && setupResp.data.RespHeader.RespStatus !== 'FAILURE') {
              if (setupOnlineTrading) {
                goToReadyBothPage();
              } else {
                goToDigitalBankReadyPage();
              }
            } else if (setupOnlineTrading) {
              goToHaveCompletedPage();
            } else {
              goToHasCompletedPage();
            }
          });
        }
      }
    });
  };

  return (
    <>
      <div className={classes.title}>
        {formRedux.form && formRedux.form.dynamicContent.setup_inb_page.TITLE}
      </div>
      <div className={classes.mb40}>
        <SectionWrapper title="">
          <DynamicMessage text={formRedux.form && formRedux.form.dynamicContent.setup_inb_page.CONTENT_TEXT} classes={classes} />
          <Grid container>
            <Grid item lg={3} md={4} sm={5} xs={12} className={classes.mt40}>
              <Input
                label="Digital banking access code"
                maxLength={14}
                placeholder=""
                preventSpecialCharacters={restrictSpecialCharacters}
                value={digitalBanking.accessCode}
                type="text"
                size="large"
                checkOnChange
                kind="accessCode"
                getValue={value => getDigitalTrading('accessCode', value.value, value.error)}
              />
              {digitalBanking.accessCode === '' && (
                <div className={classes.textBlur}>
                  {formRedux.form && formRedux.form.dynamicContent.setup_inb_page.USER_ID_TIPS}
                </div>
              )}
            </Grid>
          </Grid>
          <Grid container>
            <Grid
              item
              lg={3}
              md={4}
              sm={5}
              xs={12}
              className={clsx(classes.mt40, classes.inputWrapper)}
            >
              <CodeInputCustom
                label="Set your 6-digit PIN"
                getValue={value => getDigitalTrading('password', value, value.error)}
                onKeyPress={preventSpecialCharacters}
                value={digitalBanking.password}
                handleError={handleError}
                max={6}
                type={typePassword}
              />
              <div
                className={clsx(classes.iconCodeInput, classes.right55)}
                onClick={() => showPassword()}
                aria-hidden="true"
              >
                <img
                  src={typePassword === 'password' ? Eye : EyeSlash}
                  alt="eye"
                />
              </div>
            </Grid>
            <Grid
              item lg={1} md={1} sm={1} xs={12}
              className={classes.empty}
            />
            <Grid
              item
              lg={3}
              md={4}
              sm={5}
              xs={12}
              className={clsx(classes.mt40, classes.inputWrapper)}
            >
              <CodeInputCustom
                label="Confirm 6-digit PIN"
                getValue={value => getDigitalTrading('confirmPassword', value, value.error)}
                max={6}
                type={confirmPassword}
                value={digitalBanking.confirmPassword}
                handleError={handleError}
                inputStyle={{
                  borderBottom: '1px solid red',
                  borderRadius: '6px',
                }}
                className={
                  digitalBanking.confirmPassword.length > 0 && digitalBanking.password !== digitalBanking.confirmPassword ? classes.errorInput : ''
                }
              />
              <div
                className={clsx(classes.iconCodeInput, classes.right55)}
                onClick={() => showConfirmPassword()}
                aria-hidden="true"
              >
                <img
                  src={confirmPassword === 'password' ? Eye : EyeSlash}
                  alt="eye"
                />
              </div>
              {digitalBanking.confirmPassword.length > 0 && digitalBanking.password !== digitalBanking.confirmPassword && (
                <div className={classes.message}>{formRedux.form && formRedux.form.dynamicContent.setup_inb_page.ERROR_MSG.MSG3}</div>
              )}
            </Grid>
          </Grid>
        </SectionWrapper>
      </div>
      <div className={classes.buttonWrapperSubmit}>
        <Button
          backgroundClass="bgLipstickOrangey" onClick={() => setupInbSubmisssion()}
          disabled={!validateDigitalBanking}
        >
          Submit
        </Button>
      </div>
    </>
  );
};

export default SetupDigitalBanking;
